import {GridModel} from '@xh/hoist/cmp/grid';
import {HoistModel, managed, TaskObserver, XH} from '@xh/hoist/core';
import {action, observable} from '@xh/hoist/mobx';
import {moneyColorFormatter} from '../../../cmp/Formaters';
import {CashFlow, RealEstateDeal} from '../../../data/DataTypes';

export class CashFlowsDialogModel extends HoistModel {
    apiTask = TaskObserver.trackLast();
    @observable accessor isOpen = false;
    @managed gridModel = this.createGridModel();

    @action open(deal: RealEstateDeal) {
        this.gridModel.clear();
        this.isOpen = true;

        const cfs: CashFlow[] = [{asOfDate: deal.inceptionDate, amount: -deal.capital}];
        cfs.push(...deal.cashFlows);
        this.gridModel.loadData(cfs);
    }

    @action close() {
        this.isOpen = false;
    }

    private createGridModel(): GridModel {
        return new GridModel({
            store: {
                idSpec: () => XH.genId()
            },
            colDefaults: {
                resizable: false,
                movable: false,
                hideable: false
            },
            contextMenu: null,
            selModel: 'disabled',
            cellBorders: true,
            columns: [
                {field: 'asOfDate', width: 160},
                {field: 'amount', align: 'right', flex: 1, renderer: v => moneyColorFormatter(v)}
            ]
        });
    }
}
